import { render, staticRenderFns } from "./ItemFilterDetectionFilter.vue?vue&type=template&id=2111c801&scoped=true"
import script from "./ItemFilterDetectionFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterDetectionFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2111c801",
  null
  
)

export default component.exports